import p1 from "../assets/portfolioimages/p1.png";
import p2 from "../assets/portfolioimages/p2.png";
import p3 from "../assets/portfolioimages/p3.png";
import p4 from "../assets/portfolioimages/p4.png";
import p5 from "../assets/portfolioimages/p5.png";
import p6 from "../assets/portfolioimages/p6.png";
import p7 from "../assets/portfolioimages/p7.png";
import p8 from "../assets/portfolioimages/p8.png";
import p9 from "../assets/portfolioimages/p9.png";
import p10 from "../assets/portfolioimages/p10.png";
import p11 from "../assets/portfolioimages/p11.png";
import p12 from "../assets/portfolioimages/p12.png";
import p13 from "../assets/portfolioimages/p13.png";
import p14 from "../assets/portfolioimages/p14.png";
import p15 from "../assets/portfolioimages/p15.png";
import p16 from "../assets/portfolioimages/p16.png";
import p17 from "../assets/portfolioimages/p17.png";
import p18 from "../assets/portfolioimages/p18.png";
import p19 from "../assets/portfolioimages/p19.png";
import p20 from "../assets/portfolioimages/p20.png";
import p21 from "../assets/portfolioimages/p21.png";
import p22 from "../assets/portfolioimages/p22.png";
import p23 from "../assets/portfolioimages/p23.png";
import p24 from "../assets/portfolioimages/p24.png";
import p25 from "../assets/portfolioimages/p25.png";
import p26 from "../assets/portfolioimages/p26.png";
import p27 from "../assets/portfolioimages/p27.png";
import p28 from "../assets/portfolioimages/p28.png";
import p29 from "../assets/portfolioimages/p29.png";
import p30 from "../assets/portfolioimages/p30.png";
import p31 from "../assets/portfolioimages/p31.png";
import p32 from "../assets/portfolioimages/p32.png";
import p33 from "../assets/portfolioimages/p33.png";
import p34 from "../assets/portfolioimages/p34.png";
import p35 from "../assets/portfolioimages/p35.png";
import p36 from "../assets/portfolioimages/p36.png";
import p37 from "../assets/portfolioimages/p37.png";
import p38 from "../assets/portfolioimages/p38.png";
import p39 from "../assets/portfolioimages/p39.png";
import p40 from "../assets/portfolioimages/p40.png";
import p41 from "../assets/portfolioimages/p41.png";
import p42 from "../assets/portfolioimages/p42.png";
import p43 from "../assets/portfolioimages/p43.png";
import p44 from "../assets/portfolioimages/p44.png";
import p45 from "../assets/portfolioimages/p45.png";

export const PortfolioImages = [
    {
        id: 1,
        name:"",
        src: p1,
        alt:""
    },
    {
        id: 2,
        name:"",
        src: p2,
        alt:""
    },
    {
        id: 3,
        name:"",
        src: p3,
        alt:""
    },
    {
        id: 4,
        name:"",
        src: p4,
        alt:""
    },
    {
        id: 5,
        name:"",
        src: p5,
        alt:""
    },
    {
        id: 6,
        name:"",
        src: p6,
        alt:""
    },
    {
        id: 7,
        name:"",
        src: p7,
        alt:""
    },
    // { duplicate
    //     id: 8,
    //     name:"",
    //     src: p8,
    //     alt:""
    // },
    {
        id: 9,
        name:"",
        src: p9,
        alt:""
    },
    {
        id: 10,
        name:"",
        src: p10,
        alt:""
    },
    {
        id: 11,
        name:"",
        src: p11,
        alt:""
    },
    {
        id: 12,
        name:"",
        src: p12,
        alt:""
    },
    {
        id: 13,
        name:"",
        src: p13,
        alt:""
    },
    {
        id: 14,
        name:"",
        src: p14,
        alt:""
    },
    {
        id: 15,
        name:"",
        src: p15,
        alt:""
    },
    {
        id: 16,
        name:"",
        src: p16,
        alt:""
    },
    {
        id: 17,
        name:"",
        src: p17,
        alt:""
    },
    {
        id: 18,
        name:"",
        src: p18,
        alt:""
    },
    {
        id: 19,
        name:"",
        src: p19,
        alt:""
    },
    {
        id: 20,
        name:"",
        src: p20,
        alt:""
    },
    {
        id: 21,
        name:"",
        src: p21,
        alt:""
    },
    {
        id: 22,
        name:"",
        src: p22,
        alt:""
    },
    {
        id: 23,
        name:"",
        src: p23,
        alt:""
    },
    {
        id: 24,
        name:"",
        src: p24,
        alt:""
    },
    {
        id: 25,
        name:"",
        src: p25,
        alt:""
    },
    {
        id: 26,
        name:"",
        src: p26,
        alt:""
    },
    {
        id: 27,
        name:"",
        src: p27,
        alt:""
    },
    {
        id: 28,
        name:"",
        src: p28,
        alt:""
    },
    {
        id: 29,
        name:"",
        src: p29,
        alt:""
    },
    {
        id: 30,
        name:"",
        src: p30,
        alt:""
    },
    {
        id: 31,
        name:"",
        src: p31,
        alt:""
    },
    {
        id: 32,
        name:"",
        src: p32,
        alt:""
    },
    {
        id: 33,
        name:"",
        src: p33,
        alt:""
    },
    {
        id: 34,
        name:"",
        src: p34,
        alt:""
    },
    {
        id: 35,
        name:"",
        src: p35,
        alt:""
    },
    {
        id: 36,
        name:"",
        src: p36,
        alt:""
    },
    {
        id: 37,
        name:"",
        src: p37,
        alt:""
    },
    {
        id: 38,
        name:"",
        src: p38,
        alt:""
    },
    {
        id: 39,
        name:"",
        src: p39,
        alt:""
    },
    {
        id: 40,
        name:"",
        src: p40,
        alt:""
    },
    {
        id: 41,
        name:"",
        src: p41,
        alt:""
    },
    {
        id: 42,
        name:"",
        src: p42,
        alt:""
    },
    {
        id: 43,
        name:"",
        src: p43,
        alt:""
    },
    {
        id: 44,
        name:"",
        src: p44,
        alt:""
    },
    {
        id: 45,
        name:"",
        src: p45,
        alt:""
    },
    
]
